import Swal from "sweetalert2";
import AppUserProfile, { UserType } from "../assets/js/AppUserProfile";
import { powerBiUrl } from "../assets/js/Route";
import Layout from "../components/layouts/Layout";
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const PowerBiPage = () => {
  const navigate = useNavigate();

  const userRole = AppUserProfile.getData()["whoami"];
  const roleName = AppUserProfile.getData()["role_name"];

  const isAllow = useMemo(() => {
    if ([UserType.DEALER_BYD, UserType.DEALER_DENZA].includes(userRole)) {
      return false;
    }

    return true;
  }, [userRole, roleName]);

  useEffect(() => {
    if (!isAllow) {
      Swal.fire({
        html: `<h4>คุณไม่มีสิทธิ์ในการเข้าถึง</h4>`,
        icon: "warning",
        confirmButtonText: "ไปหน้าแรก",
      }).then((result) => {
        const currentParams = new URLSearchParams(window.location.search);
        if (result.isConfirmed) {
          navigate(`/?${currentParams.toString()}`);
        } else {
          navigate(`/?${currentParams.toString()}`);
        }
      });
    }
  }, [userRole]);

  return (
    <>
      <Layout>
        {isAllow && (
          <iframe
            src={powerBiUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Embedded Site"
            sandbox="allow-scripts allow-same-origin"
          />
        )}
      </Layout>
    </>
  );
};

export default PowerBiPage;
